import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const EngineTypeName = ({ form, disabled, engineTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Тип двигателя:</span>
      <Form.Item>
        {getFieldDecorator('engineTypeName')(
          <Select
            placeholder="Выберите тип двигателя"
            className="basicInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {engineTypes &&
              engineTypes.map((type, index) => (
                <Select.Option
                  value={type.vehicleEngineTypeId}
                  key={index}
                  label={type.engineTypeName}
                >
                  {type.engineTypeName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(EngineTypeName, ['engineTypes']);
